import React from 'react';
import { IonItem, IonLabel, IonIcon } from '@ionic/react';
import { 
  chevronDown, 
  chevronForward, 
  informationCircle, 
  list, 
  pricetag 
} from 'ionicons/icons';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  isExpanded?: boolean;
  onToggle?: () => void;
  children?: React.ReactNode;
}

// Icon mapping from string names to icon objects
const iconMap: Record<string, any> = {
  'information-circle': informationCircle,
  'list': list,
  'pricetag': pricetag,
};

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  icon,
  isExpanded = true,
  onToggle,
  children
}) => {
  return (
    <div style={{ 
      marginTop: '1rem',
      marginBottom: '0.25rem',
      borderBottom: '2px solid var(--ion-color-primary)',
      paddingBottom: '0.25rem'
    }}>
      <IonItem 
        button={!!onToggle}
        onClick={onToggle}
        style={{ 
          '--background': 'transparent',
          '--padding-start': '0',
          '--padding-end': '0',
          '--inner-padding-end': '0'
        }}
      >
        {icon && (
          <IonIcon 
            icon={iconMap[icon] || icon} 
            slot="start" 
            style={{ 
              color: 'var(--ion-color-primary)',
              marginRight: '0.5rem'
            }}
          />
        )}
        <IonLabel>
          <h2 style={{ 
            margin: 0, 
            color: 'var(--ion-color-primary)',
            fontSize: '1.1em',
            fontWeight: 'bold'
          }}>
            {title}
          </h2>
          {subtitle && (
            <p style={{ 
              margin: '0.25rem 0 0 0',
              color: 'var(--ion-color-medium)',
              fontSize: '0.9em'
            }}>
              {subtitle}
            </p>
          )}
        </IonLabel>
        {onToggle && (
          <IonIcon 
            icon={isExpanded ? chevronDown : chevronForward}
            slot="end"
            style={{ color: 'var(--ion-color-medium)' }}
          />
        )}
      </IonItem>
      {isExpanded && children && (
        <div style={{ marginTop: '0.25rem' }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
